import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import { initGA } from '../utils/analytics';

export default function CookieBanner({ onOpenSettings }) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('maaich-cookie-consent');
    if (!consent) {
      setIsVisible(true);
    } else if (consent === 'accepted') {
      initGA();
    }
  }, []);

  const handleConsent = (status) => {
    localStorage.setItem('maaich-cookie-consent', status);
    localStorage.setItem('maaich-consent-date', new Date().toISOString());
    setIsVisible(false);
    if (status === 'accepted') {
      initGA();
    }
  };

  // Funzione esportata per riaprire il banner
  window.openCookieBanner = () => setIsVisible(true);

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div 
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          className="fixed bottom-0 left-0 w-full z-[200] p-4 md:p-6"
        >
          <div className="container mx-auto max-w-4xl bg-maaich-black border border-white/10 shadow-2xl p-6 md:p-8 rounded-lg flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="text-left">
              <h4 className="font-display uppercase text-white mb-2">Informativa sui Cookie</h4>
              <p className="text-sm text-white/60 font-body leading-relaxed max-w-2xl">
                Utilizziamo i cookie per migliorare la tua esperienza e analizzare il traffico. Cliccando su "Accetta", acconsenti all'uso di Google Analytics per finalità statistiche. Puoi consultare la nostra <Link to="/cookie-policy" className="text-maaich-lime underline">Cookie Policy</Link> per maggiori dettagli.
              </p>
            </div>
            <div className="flex gap-4 w-full md:w-auto">
              <button 
                onClick={() => handleConsent('rejected')}
                className="flex-1 md:flex-none px-6 py-3 border border-white/20 text-white font-display uppercase italic text-sm hover:bg-white/10 transition-colors"
              >
                Rifiuta
              </button>
              <button 
                onClick={() => handleConsent('accepted')}
                className="flex-1 md:flex-none px-8 py-3 bg-maaich-lime text-black font-display uppercase italic text-sm hover:bg-white transition-colors"
              >
                Accetta
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}